// src/lib/config.js: Haalt runtime-config op via Supabase get_config RPC.
// Exporteert een `config` object dat ná bootstrap is gevuld; importeer hem
// alleen in code die uitgevoerd wordt nadat `bootstrapConfig()` is afgerond.
//
// URL-param ?versie=2026.1 → vraag die versie op. Onbekend/niet-leesbaar → fallback
// op actieve versie + banner.

const SUPABASE_URL      = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  throw new Error(
    "VITE_SUPABASE_URL en VITE_SUPABASE_ANON_KEY moeten in .env.local staan. " +
    "Kopieer .env.example naar .env.local en vul ze in."
  );
}

// Mutable config-object: properties worden gevuld door applyConfig().
// Rollen + timesheets zitten statisch in app/src/data/, niet meer in de RPC.
export const config = {
  tarieven_film_av: [],
  tarieven_festival: [],
  tarieven_festival_loondienst: [],
  opslag_film_av: [],
  opslag_festival: [],
  toeslagen: {},
  generiek: {},
};

// Berekende totalen: handig voor UI.
export const opslag = {
  totaalFilmAV: 0,
  totaalFestival: 0,
};

// Banner-state voor de UI (warning/error/info).
export const configBanner = { value: null };

async function fetchConfig(versie) {
  const res = await fetch(`${SUPABASE_URL}/rest/v1/rpc/get_config`, {
    method: "POST",
    headers: {
      "apikey":        SUPABASE_ANON_KEY,
      "Authorization": `Bearer ${SUPABASE_ANON_KEY}`,
      "Content-Type":  "application/json",
    },
    body: JSON.stringify({ p_versie: versie || null }),
  });
  if (!res.ok) throw new Error(`get_config HTTP ${res.status}`);
  return res.json();
}

function applyConfig(cfg) {
  Object.assign(config, cfg);
  opslag.totaalFilmAV  = (cfg.opslag_film_av  || []).reduce((s, o) => s + Number(o.pct || 0), 0);
  opslag.totaalFestival = (cfg.opslag_festival || []).reduce((s, o) => s + Number(o.pct || 0), 0);
}

export async function bootstrapConfig() {
  const params = new URLSearchParams(location.search);
  const gevraagdeVersie = params.get("versie");

  let cfg = await fetchConfig(gevraagdeVersie);

  if (cfg == null && gevraagdeVersie) {
    configBanner.value = {
      type: "warning",
      text: `Versie "${gevraagdeVersie}" is niet beschikbaar. Actieve versie wordt getoond.`,
    };
    cfg = await fetchConfig(null);
  }

  if (cfg == null) {
    throw new Error("get_config leverde null op voor actieve versie");
  }

  applyConfig(cfg);
}
